import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="bg-gray-50 py-4 px-4" data-id="element-407">
      <div className="max-w-6xl mx-auto" data-id="element-408">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-3" data-id="element-409">
          Testimonios de Docentes
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-410">
          {/* Testimonial 1 */}
          <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-411">
            <div className="flex gap-1 mb-1" data-id="element-412">
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-413" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-414" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-415" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-416" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-417" />
            </div>
            <p className="text-gray-700 italic mb-2 flex-grow" data-id="element-418">
              "Mis alumnos ahora entienden qué es la inflación y cómo les
              afecta. Las clases son otra cosa."
            </p>
            <div className="mt-auto border-t pt-2" data-id="element-419">
              <p className="font-bold text-gray-900" data-id="element-420">Mariana L.</p>
              <p className="text-sm text-gray-500" data-id="element-421">38 años, Córdoba</p>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-422">
            <div className="flex gap-1 mb-1" data-id="element-423">
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-424" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-425" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-426" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-427" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-428" />
            </div>
            <p className="text-gray-700 italic mb-2 flex-grow" data-id="element-429">
              "Nunca encontré material de educación financiera adaptado a
              Argentina. Este kit me salvó el año."
            </p>
            <div className="mt-auto border-t pt-2" data-id="element-430">
              <p className="font-bold text-gray-900" data-id="element-431">Sebastián D.</p>
              <p className="text-sm text-gray-500" data-id="element-432">42 años, Buenos Aires</p>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-433">
            <div className="flex gap-1 mb-1" data-id="element-434">
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-435" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-436" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-437" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-438" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-439" />
            </div>
            <p className="text-gray-700 italic mb-2 flex-grow" data-id="element-440">
              "Los chicos se enganchan con los ejemplos de Mercado Pago y
              criptomonedas. Por fin algo que les interesa."
            </p>
            <div className="mt-auto border-t pt-2" data-id="element-441">
              <p className="font-bold text-gray-900" data-id="element-442">Claudia R.</p>
              <p className="text-sm text-gray-500" data-id="element-443">35 años, Rosario</p>
            </div>
          </div>

          {/* Testimonial 4 */}
          <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-444">
            <div className="flex gap-1 mb-1" data-id="element-445">
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-446" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-447" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-448" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-449" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-450" />
            </div>
            <p className="text-gray-700 italic mb-2 flex-grow" data-id="element-451">
              "La planificación anual y las rúbricas me ahorraron semanas de
              trabajo. Todo listo para presentar."
            </p>
            <div className="mt-auto border-t pt-2" data-id="element-452">
              <p className="font-bold text-gray-900" data-id="element-453">Pablo M.</p>
              <p className="text-sm text-gray-500" data-id="element-454">45 años, Mendoza</p>
            </div>
          </div>

          {/* Testimonial 5 */}
          <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100 flex flex-col h-full md:col-span-2 lg:col-span-1 lg:col-start-2" data-id="element-455">
            <div className="flex gap-1 mb-1" data-id="element-456">
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-457" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-458" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-459" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-460" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-461" />
            </div>
            <p className="text-gray-700 italic mb-2 flex-grow" data-id="element-462">
              "El módulo de estafas digitales fue un éxito total. Los padres me
              agradecieron."
            </p>
            <div className="mt-auto border-t pt-2" data-id="element-463">
              <p className="font-bold text-gray-900" data-id="element-464">Luciana V.</p>
              <p className="text-sm text-gray-500" data-id="element-465">33 años, Tucumán</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}